import React, { ReactNode } from 'react';
import { Element } from './TabContent.styles';
import { useTabContext } from '@/components/tab';

export interface TabContentProps {
  id: string;
  className?: string;
  children?: ReactNode;
}

const TabContent = ({ id, children, ...props }: TabContentProps) => {
  const { tabActive } = useTabContext();
  return (
    <Element role="tabpanel" aria-labelledby={`tab-${id}`} id={`tab-panel-${id}`} active={tabActive === id} {...props}>
      {children}
    </Element>
  );
};

export default TabContent;
